import {useEffect, useState, startTransition} from "react"

export const useMediaQuery = (mediaQueryString: string): boolean => {
    // Default to false during SSR to ensure consistent initial render
    const [matches, setMatches] = useState<boolean>(false)

    useEffect(() => {
        // Strip @media prefix if present (for Material-UI theme.breakpoints compatibility)
        const cleanMediaQuery = mediaQueryString.replace(/^@media\s+/, "")
        const mediaQueryList = window.matchMedia(cleanMediaQuery)
        const listener = () => startTransition(() => setMatches(!!mediaQueryList.matches))
        listener()
        mediaQueryList.addEventListener("change", listener)
        return () => mediaQueryList.removeEventListener("change", listener)
    }, [mediaQueryString])

    return matches
}

export default useMediaQuery
